import { GatewayChat } from "./GatewayChat"

export type ChatMessage = {
  messageType: "Question" | "Response" | "Error"
  text: string
  /** Product ids the assistant suggested with this answer, most relevant first. */
  productIds?: string[]
}

export const AIChat = ({
  isOpen,
  onClose,
}: {
  isOpen: boolean
  onClose: () => void
}) => <GatewayChat isOpen={isOpen} onClose={onClose} />
